import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class ImageHorizontalBorder extends AbstractProvidedClass {
    defaultTolerance = this.mobile ? 12 : 7;

    constructor(provider, parent, corner1, corner2) {
        super(provider);
        this.parent = parent;
        this.corner1 = corner1;
        this.corner2 = corner2;
    }

    setOpposite(border) {
        this.opposite = border;
    }

    hovered(viewX, viewY) {
        return this.currentMinX <= viewX
            && this.currentMaxX >= viewX
            && this.currentMinY <= viewY
            && this.currentMaxY >= viewY;
    }

    updatePositions() {
        let [viewX, viewY] = this.view.getRelative(this.parent.currentX, this.parent.currentY, this.parent.rotation); // Relative yPosition of the mouse to the center of the element
        let factorY = viewY < 0 ? -1 : 1;
        viewY = factorY * Math.min(Math.abs(viewY), Math.abs(viewX / this.parent.ratio));

        let absY = viewY / this.view.scale; // Raw yPosition of the mouse in the image
        let absdY = (absY - this.corner1.absY); // The difference between the mouse position and the border position
        this.corner1.absY += absdY; // Move the border
        this.corner2.absY += absdY; // Move the border
        let avgY = (this.corner1.absY + this.opposite.corner1.absY) / 2; // The average yPosition of the two borders (the new center of the element)

        // Update the center of the element
        this.parent.absX += avgY * Math.cos(this.parent.rotation + Math.PI / 2);
        this.parent.absY += avgY * Math.sin(this.parent.rotation + Math.PI / 2);
    }

    move(dx, dy) {
        if (dy == 0) {
            return;
        }
        this.corner1.absY += dy;
        this.corner2.absY += dy;
        this.parent.center.absY += dy / 2;
        this.parent.row.updateImg();
        this.getTab('info').input.height.value(this.calculatePixelToDisplayDistance(this.parent.height));
    }

    mouseOver(viewX, viewY) {
        if (!this.hovered(viewX, viewY)) {
            return false;
        }

        this.cursor.resizeVertical(this.parent.rotation);
        return true;
    }

    get absY() {
        return this.corner1.absY;
    }

    get currentMinY() {
        return this.corner1.currentY - this.tolerance;
    }

    get currentMaxY() {
        return this.corner1.currentY + this.tolerance;
    }

    get currentMinX() {
        return Math.min(this.corner1.currentX, this.corner2.currentX);
    }

    get currentMaxX() {
        return Math.max(this.corner1.currentX, this.corner2.currentX);
    }

    get tolerance() {
        return Math.min(this.defaultTolerance, this.parent.currentHeight / 10)
    }
}
